export default "__VITE_ASSET__NNs5tZky__"